import * as yup from "yup";

const model = {
  bankName: "",
  accountNumber: "",
  ifscCode: "",
  branch: "",
  shortCode: "",
  swiftCode: "",
  address: "",
  remarks: "",
  status: false,
};

const validationModel = yup.object().shape({
  bankName: yup.string().required("Bank Name is required!"),
  accountNumber: yup.string().required("A/c Number is required!"),
  ifscCode: yup.string().required("IFSC Code is required!"),
  branch: yup.string().required("Branch Name is required!"),
  shortCode: yup.string().required("Bank Short Code is required!"),
  swiftCode: yup.string().required("SwiftCode is required!"),
  address: yup.string().required("Address is required!"),
  remarks: yup.string(),
});
export { model, validationModel };
